import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { Orders } from '@hellohair/types';
import { useStyles } from '../../../theme/styles.helpers';
import { RequestModalStyles } from './RequestModal.Styles';

const getActiveIngredient = (product?: Orders.ShopifyRecipeInformation) => {
  return product?.productComposition ?? '-';
};

const getTreatmentDuration = (product?: Orders.ShopifyRecipeInformation) => {
  return product?.productValidityPeriod ?? '-';
};

const getTreatmentForm = (product?: Orders.ShopifyRecipeInformation) => {
  return product?.productDosageForm ?? '-';
};

const getTreatmentDosage = (product?: Orders.ShopifyRecipeInformation) => {
  return product?.productUseInstructions ?? '-';
};

interface RequestModalDosierungProps {
  product: Orders.OrderProduct;
}

export const RequestModalDosierung: FC<RequestModalDosierungProps> = ({ product }) => {
  const styles = useStyles(RequestModalStyles, {});

  const _product = Array.isArray(product.recipeInformation) ? product.recipeInformation[0] : product.recipeInformation;

  return (
    <Box sx={styles.card}>
      <Typography sx={styles.cardLabel}>Dosierung & Rezept</Typography>
      <Box sx={styles.infoGrid}>
        <Box sx={styles.infoCell}>
          <Typography sx={styles.infoCellLabel}>Wirkstoff</Typography>
          <Typography sx={styles.infoCellValue}>{getActiveIngredient(_product)}</Typography>
        </Box>
        <Box sx={styles.infoCell}>
          <Typography sx={styles.infoCellLabel}>Darreichungsform</Typography>
          <Typography sx={styles.infoCellValue}>{getTreatmentForm(_product)}</Typography>
        </Box>
        <Box sx={styles.infoCell}>
          <Typography sx={styles.infoCellLabel}>Dosierung</Typography>
          <Typography sx={styles.infoCellValue}>{getTreatmentDosage(_product)}</Typography>
        </Box>
        <Box sx={styles.infoCell}>
          <Typography sx={styles.infoCellLabel}>Behandlungsdauer</Typography>
          <Typography sx={styles.infoCellValue}>{getTreatmentDuration(_product)}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
